import Api from '@/services/Api'
import { Trans } from '@/services/TranslationService'
import updateChecker from '@/shared/js/vuex/modules/updateChecker'

export default updateChecker({ Api, Trans })
